import { useMemo } from "react"

import { useSearch } from "features/search/context"
import { KojinResult } from "interface/kojin"
import { Section, SectionProps } from "components/controls/section"
import { Stack, Typography } from "@mui/material"

type KojinMetaTagsProps = {
	kojin: KojinResult | null
} & SectionProps
export const KojinMetaTags = ({
	kojin,
	...others
}: KojinMetaTagsProps) => {
	const search = useSearch()
	const master = useMemo(
		() => search?.metaTag ?? [],
		[search]
	)
	const metaTags = useMemo(
		() => {
			if (!master || !kojin || !kojin.metaTag || kojin.metaTag.length === 0) return []
			return master.flatMap(({ key, label }) => {
				const values = kojin.metaTag?.flatMap(kojinsMetaTag => kojinsMetaTag.key === key ? kojinsMetaTag.value : []) ?? []
				if (values.length === 0) return []
				return { key, label, values }
			})
		},
		[master, kojin]
	)
	return metaTags.map(
		({ key, label, values }) => (
			<Section
				key={`metatag-${key}`}
				label={label}
				{...others}
			>
				<Stack direction="row">
					{values.map((value, i) => (
						<Typography
							key={`metatag-${key}-${i}`}
							variant="body2" color='text.primary' component="span"
						>
							{value}
							{(i < (values.length - 1)) ? "、" : ""}
						</Typography>
					))}
				</Stack>
			</Section>
		)
	)
}
